export default "__VITE_ASSET__Cv$m1E_g__"